import { Body1, Image, Link, TooltipDesktop } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './Participation.css';
import { IAgentCardParticipation } from '../../types/agentCard';

export type TParticipationProps = {
  participation: IAgentCardParticipation;
};

export const Participation: React.FC<TParticipationProps> = ({ participation }) => {
  const { title, description, iconUrl, infoUrl, infoTitle } = participation;

  const tooltip = (
    <div className={styles['tooltip']}>
      <Body1>{description}</Body1>
      <Link href={infoUrl} target="_blank" rel="noreferrer" fontSize="M">
        {infoTitle}
      </Link>
    </div>
  );

  return (
    <TooltipDesktop title={tooltip} theme="white" placement="bottom-start">
      <div className={styles['trigger']} data-name="Participation">
        <span className={styles['icon']}>
          <Image src={iconUrl} width={24} height={24} objectFit="contain" borderRadius={0} preloader={false} />
        </span>
        <Body1>{title}</Body1>
      </div>
    </TooltipDesktop>
  );
};
